// extracted by mini-css-extract-plugin
export default {"photos":"Photos_photos__kwo+s","landscape":"Photos_landscape__N-9Xx","top-portrait":"Photos_top-portrait__S+kNi","bottom-portrait":"Photos_bottom-portrait__gwWxS"};